exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user_name{\r\n    font-size:14px;\r\n    font-weight: bold;\r\n}\r\n\r\n.comments-list .media{\r\n    border-bottom: 1px dotted #ccc;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/comentario-ocorrencia/comentario-ocorrencia.component.css
// module id = ../../../../../src/app/ocorrencias/comentario-ocorrencia/comentario-ocorrencia.component.css
// module chunks = main